<script>
import { uniqueId } from 'lodash-es';
import { GlIcon, GlPopover, GlLink } from '@gitlab/ui';

export const i18n = {
  helpTitle: 'What is a Tax ID?',
  helpText:
    'Tax ID is used to calculate tax exemption for non-US customers. Enter your VAT, GST, DST, or other regional tax identification number.',
  learnMoreText: 'Learn more',
  learnMoreUrl:
    'https://docs.gitlab.com/subscriptions/billing_account/#tax-id-for-non-us-customers',
};

export default {
  name: 'TaxIdHelpIconPopover',
  components: {
    GlIcon,
    GlPopover,
    GlLink,
  },
  data() {
    return {
      targetId: uniqueId('tax-id-help-icon-'),
    };
  },
  i18n,
};
</script>

<template>
  <span>
    <gl-icon
      :id="targetId"
      name="question-o"
      class="gl-mb-1 gl-cursor-help gl-text-blue-500"
      :size="14"
      data-testid="help-icon"
      tabindex="0"
      aria-label="Help for Tax ID"
    />
    <gl-popover
      :target="targetId"
      triggers="hover focus"
      placement="top"
      data-testid="help-icon-popover"
    >
      <strong>{{ $options.i18n.helpTitle }}</strong>
      <span class="gl-block gl-my-3">{{ $options.i18n.helpText }}</span>
      <gl-link :href="$options.i18n.learnMoreUrl" target="_blank">{{
        $options.i18n.learnMoreText
      }}</gl-link>
    </gl-popover>
  </span>
</template>
